import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { GeographicalProjectLink } from '../../data-access/geographical-summary.types';

type SortField = 'projectName' | 'projectType' | 'projectStage' | 'startupYear';
type SortDirection = 'asc' | 'desc';

@Component({
    selector: 'app-geographical-projects-list',
    templateUrl: './geographical-projects-list.component.html',
    styleUrls: ['./geographical-projects-list.component.scss']
})
export class GeographicalProjectsListComponent implements OnChanges {
    @Input() projects: GeographicalProjectLink[] = [];
    @Output() projectSelected = new EventEmitter<GeographicalProjectLink>();

    selectedProjectId: number | null = null;
    sortField: SortField = 'projectName';
    sortDirection: SortDirection = 'asc';

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.projects) {
            return;
        }

        if (this.selectedProjectId == null) {
            return;
        }

        const stillExists = (this.projects || []).some((project) => project.projectId === this.selectedProjectId);
        if (!stillExists) {
            this.selectedProjectId = null;
        }
    }

    get sortedProjects(): GeographicalProjectLink[] {
        const items = [...(this.projects || [])];
        const direction = this.sortDirection === 'asc' ? 1 : -1;

        return items.sort((a, b) => {
            const aValue = a[this.sortField];
            const bValue = b[this.sortField];

            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return (aValue - bValue) * direction;
            }

            return String(aValue || '').localeCompare(String(bValue || '')) * direction;
        });
    }

    onSort(field: SortField): void {
        if (this.sortField === field) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
            return;
        }

        this.sortField = field;
        this.sortDirection = 'asc';
    }

    isSelected(project: GeographicalProjectLink): boolean {
        return this.selectedProjectId === project.projectId;
    }

    sortIndicator(field: SortField): string {
        if (this.sortField !== field) {
            return '';
        }

        return this.sortDirection === 'asc' ? '▲' : '▼';
    }

    selectProject(project: GeographicalProjectLink): void {
        this.selectedProjectId = project.projectId;
        this.projectSelected.emit(project);
    }
}
